import ApiService from './ApiService'

export const getApiData = (data) => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
        }
        data.sort?.map((sort) => {
            if (!sort.order) return sort
            datas.ordering =
                sort.order === 'desc' ? `-${sort.key}` : `${sort.key}`
            return sort
        })
        if (data.query) {
            datas.search = data.query
        }
        if (data.selectedTab) {
            datas.status = data.selectedTab
        }
        if (data.service) {
            datas.assignment__service = data.service
        }
    }
    return ApiService.get('/rate-card-template/extra-charges/', datas)
}
export const createApiRecord = (data) =>
    ApiService.post('/rate-card-template/extra-charges/', data)
export const getApiRecord = (id) =>
    ApiService.get(`/rate-card-template/extra-charges/${id}`)
export const updateApiRecord = (id, data) =>
    ApiService.put(`/rate-card-template/extra-charges/${id}/`, data)
export const updateApiStatus = (id, data) =>
    ApiService.patch(`/rate-card-template/extra-charges/${id}/`, data)
export const deleteApiRecord = (id) =>
    ApiService.delete('/rate-card-template/extra-charges', id)
